<template>
  <div class>
    <div v-if="tradeDetail && tradeDetail.isDelete != 1" class="pocket-wrap"
      :class="{ 'pocket-wrap-dark': skinModel == '1' }">
      <div class="trade-base-info" v-if="tradeDetail.orderType != 2">
        <p class="trade-money" v-if="!tradeDetail.currencyType || tradeDetail.currencyType == '0'">
          ￥{{ tradeDetail.orderAmount | amount_convert }}
        </p>
        <p class="trade-money" v-if="tradeDetail.currencyType == '1'">
          {{ tradeDetail.orderAmount }}<span>铛铛币</span>
        </p>
        <p class="trade-ways">{{ tradeDetail.headTitle }}</p>
      </div>

      <div class="trade-base-info-tixian" v-if="tradeDetail.orderType == 2">
        <img :src="tradeDetail.tradeObjectImage" class="trade-object-image">
        <p class="trade-ways">{{ tradeDetail.headTitle }}</p>
        <p class="trade-money">
          ￥{{ tradeDetail.orderAmount | amount_convert }}
        </p>
      </div>

      <ul class="trade-detail-info" v-if="tradeDetail.orderType != 2">
        <li v-if="tradeDetail.traderDesc" class="detail-item">
          <span class="detail-sub-title">{{ tradeDetail.traderDesc }}</span>
          <span class="detail-sub-content">{{ tradeDetail.trader }}</span>
        </li>
        <li v-if="tradeDetail.serviceCharge" class="detail-item">
          <span class="detail-sub-title">手续费</span>
          <span class="detail-sub-content">￥{{ tradeDetail.serviceCharge | amount_convert }}</span>
        </li>
        <li class="detail-item">
          <span class="detail-sub-title">当前状态</span>
          <span class="detail-sub-content">
            {{ tradeDetail.tradeStatusDesc }}
          </span>
        </li>
        <li v-if="
          tradeDetail.orderType != 1 &&
          tradeDetail.orderType != 2 &&
          tradeDetail.orderType != 17 &&
          tradeDetail.orderType != 18
        " class="detail-item">
          <span class="detail-sub-title">交易类型</span>
          <span class="detail-sub-content" :class="{ 'red-envelope': red_envelope }" @click="redEnvelope">{{
            tradeDetail.orderTypeDesc }}</span>
        </li>
        <li v-if="
          tradeDetail.orderType == 24 &&
          tradeDetail.tradeExtInfo.liveStartTime
        " class="detail-item">
          <span class="detail-sub-title">开播时间</span>
          <span class="detail-sub-content">{{
            tradeDetail.tradeExtInfo.liveStartTime
          }}</span>
        </li>
        <li v-if="
          tradeDetail.orderType == 24 && tradeDetail.tradeExtInfo.liveEndTime
        " class="detail-item">
          <span class="detail-sub-title">下播时间</span>
          <span class="detail-sub-content">{{
            tradeDetail.tradeExtInfo.liveEndTime
          }}</span>
        </li>
        <li class="detail-item" v-if="
          tradeDetail.orderType == 24 && tradeDetail.tradeExtInfo.liveDuration
        ">
          <span class="detail-sub-title">直播时长</span>
          <span class="detail-sub-content">{{
            tradeDetail.tradeExtInfo.liveDuration
          }}</span>
        </li>
        <li class="detail-item" v-if="
          tradeDetail.orderType == 24 && tradeDetail.tradeExtInfo.receiveDDB
        ">
          <span class="detail-sub-title">本场获得铛铛币</span>
          <span class="detail-sub-content">{{
            tradeDetail.tradeExtInfo.receiveDDB
          }}</span>
        </li>
        <li class="detail-item" v-if="
          tradeDetail.orderType == 24 && tradeDetail.tradeExtInfo.settleRatio
        ">
          <span class="detail-sub-title">分成比<span class="settleRatio" @click="settleRatio"></span></span>
          <span class="detail-sub-content">{{
            tradeDetail.tradeExtInfo.settleRatio
          }}</span>
        </li>
        <li class="detail-item" v-if="
          tradeDetail.orderType == 24 &&
          tradeDetail.tradeExtInfo.currTaxAmount
        ">
          <span class="detail-sub-title">预扣税款<span class="currTaxAmount" @click="currTaxAmount"></span></span>
          <span class="detail-sub-content">{{
            tradeDetail.tradeExtInfo.currTaxAmount
          }}</span>
        </li>

        <li v-if="tradeDetail.startTimeDesc" class="detail-item">
          <span class="detail-sub-title">{{ tradeDetail.startTimeDesc }}</span>
          <span class="detail-sub-content">{{ tradeDetail.startTime }}</span>
        </li>
        <li v-if="tradeDetail.tradeExtInfo && tradeDetail.tradeExtInfo.refundType" class="detail-item">
          <span class="detail-sub-title">{{
            tradeDetail.tradeExtInfo.refundType
          }}</span>
          <span class="detail-sub-content">{{
            tradeDetail.tradeExtInfo.refundTypeDesc
          }}</span>
        </li>
        <li v-if="tradeDetail.endTimeDesc" class="detail-item">
          <span class="detail-sub-title">{{ tradeDetail.endTimeDesc }}</span>
          <span class="detail-sub-content">{{ tradeDetail.endTime }}</span>
        </li>
        <li v-if="tradeDetail.failReason" class="detail-item">
          <span class="detail-sub-title detail-sub-failreason">退款原因</span>
          <span class="detail-sub-content">{{ tradeDetail.failReason }}</span>
        </li>
        <li v-if="tradeDetail.orderType == 2 && tradeDetail.payTypeDesc" class="detail-item">
          <span class="detail-sub-title">提现方式</span>
          <span class="detail-sub-content">{{ tradeDetail.payTypeDesc }}</span>
        </li>
        <li v-if="tradeDetail.orderType != 2 && tradeDetail.payTypeDesc" class="detail-item">
          <span class="detail-sub-title">支付方式</span>
          <span class="detail-sub-content">{{ tradeDetail.payTypeDesc }}</span>
        </li>
        <li class="detail-item">
          <span class="detail-sub-title">交易单号</span>
          <span class="detail-sub-content">{{ tradeDetail.tradeId }}</span>
        </li>
        <li class="detail-item" v-if="tradeDetail.itemExplain && tradeDetail.itemExplainDesc">
          <span class="detail-sub-title">{{ tradeDetail.itemExplain }}</span>
          <span class="detail-sub-content">{{
            tradeDetail.itemExplainDesc
          }}</span>
        </li>
        <li v-if="tradeDetail.tradeExtInfo && tradeDetail.tradeExtInfo.shopName" class="detail-item">
          <span class="detail-sub-title">商家信息</span>
          <span class="detail-sub-content red-envelope" @click="goShop">
            {{ tradeDetail.tradeExtInfo.shopName }}
          </span>
        </li>
        <li v-if="
          tradeDetail.tradeExtInfo && tradeDetail.tradeExtInfo.goodsOrderId
        " class="detail-item">
          <span class="detail-sub-title">订单编号</span>
          <span class="detail-sub-content">
            {{ tradeDetail.tradeExtInfo.goodsOrderId }}
          </span>
        </li>
        <li v-if="tradeDetail.tradeExtInfo && tradeDetail.tradeExtInfo.goodsName" class="detail-item">
          <span class="detail-sub-title">商品说明</span>
          <span class="detail-sub-content">
            <span class="goods-name">
              {{ tradeDetail.tradeExtInfo.goodsName }}
            </span>
            x{{ tradeDetail.tradeExtInfo.amount }}
          </span>
        </li>
      </ul>

      <ul class="trade-detail-info" v-if="tradeDetail.orderType == 2">
        <li class="detail-item">
          <span class="detail-sub-title">当前状态</span>
          <span class="detail-sub-content">{{ tradeDetail.tradeStatusDesc }}</span>
        </li>
        <li class="detail-item">
          <span class="detail-sub-title">提现金额</span>
          <span class="detail-sub-content">￥{{ tradeDetail.orderAmount | amount_convert }}</span>
        </li>
        <li v-if="tradeDetail.serviceCharge" class="detail-item">
          <span class="detail-sub-title">手续费</span>
          <span class="detail-sub-content">￥{{ tradeDetail.serviceCharge | amount_convert }}</span>
        </li>
        <li v-if="tradeDetail.traderDesc" class="detail-item">
          <span class="detail-sub-title">{{ tradeDetail.traderDesc }}</span>
          <span class="detail-sub-content">{{ tradeDetail.trader }}</span>
        </li>
        <li v-if="tradeDetail.startTimeDesc" class="detail-item">
          <span class="detail-sub-title">{{ tradeDetail.startTimeDesc }}</span>
          <span class="detail-sub-content">{{ tradeDetail.startTime }}</span>
        </li>
        <li v-if="tradeDetail.endTimeDesc" class="detail-item">
          <span class="detail-sub-title">{{ tradeDetail.endTimeDesc }}</span>
          <span class="detail-sub-content">{{ tradeDetail.endTime }}</span>
        </li>
        <li v-if="tradeDetail.failReason" class="detail-item">
          <span class="detail-sub-title detail-sub-failreason">退款原因</span>
          <span class="detail-sub-content">{{ tradeDetail.failReason }}</span>
        </li>
        <li class="detail-item">
          <span class="detail-sub-title">提现方式</span>
          <span class="detail-sub-content">{{ tradeDetail.payTypeDesc }}</span>
        </li>
        <li class="detail-item">
          <span class="detail-sub-title">交易单号</span>
          <span class="detail-sub-content">{{ tradeDetail.tradeId }}</span>
        </li>
      </ul>
    </div>
    <div v-if="tradeDetail && tradeDetail.isDelete == 1" class="no-pocket-wrap">账单详情已被删除</div>
    <div v-if="loading" class="spinner-wrap">
      <div class="snake-wrap">
        <mt-spinner type="triple-bounce"></mt-spinner>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import Vue from "vue";
import encrypt from "components/plugin/lib/encrypt.js";
import setupWebViewJavascriptBridge from "components/plugin/lib/setupWebViewJavascriptBridge.js";

Vue.filter("amount_convert", function (val) {
  return (val / 100).toFixed(2);
});

export default {
  data() {
    return {
      tradeDetail: null,
      red_envelope: false, // 蓝色字体 && 可以跳走
      loading: 1,
      ddtoken: "",
      userId: "",
      circleId: "",
      bridge: "",
      ownerType: "",
      ownerId: "",
      skinModel: "0"
    };
  },
  beforeRouteEnter(to, from, next) {
    let skinModel = to.query.skinModel;
    if (skinModel == "1") {
      document.documentElement.style.backgroundColor = "#191919";
      document.body.style.backgroundColor = "#191919";
    }
    var id = to.query.tradeId;
    var ddtoken = to.query.ddtoken;
    var userId = to.query.userId;
    var ownerId = to.query.ownerId;
    var ownerType = to.query.ownerType || "";
    var circleId = to.query.circleId || "";
    const { appVersion, platform } = to.query;
    if (id && userId) {
      let params = {
        userId,
        tradeId: id,
        appVersion,
        platform
      };

      if (ddtoken) {
        params.ddtoken = decodeURIComponent(ddtoken);
      }

      if (ownerType) {
        params.ownerType = ownerType;
        params.ownerId = ownerId;
      }
      if (circleId) {
        params.circleId = circleId;
      }

      Vue.http
        .get("/pay/v1/trade/detail", {
          params: encrypt(params)
        })
        .then(res => {
          if (res.body.status != 1) return;

          next(vm => {
            let tradeDetail = res.body.data.tradeDetail;
            vm.tradeDetail = tradeDetail;
            vm.red_envelope =
              tradeDetail.orderType == 3 ||
              tradeDetail.orderType == 4 ||
              tradeDetail.orderType == 7 ||
              tradeDetail.orderType == 8 ||
              tradeDetail.orderType == 11 ||
              tradeDetail.orderType == 14 ||
              tradeDetail.orderType == 15 ||
              tradeDetail.orderType == 16 ||
              tradeDetail.orderType == 19 ||
              (tradeDetail.orderType == 22 &&
                tradeDetail.tradeExtInfo &&
                tradeDetail.tradeExtInfo.bizType &&
                tradeDetail.tradeExtInfo.bizType != 5 &&
                tradeDetail.tradeExtInfo.bizType != 4) ||
              (tradeDetail.orderType == 20 &&
                tradeDetail.tradeExtInfo &&
                tradeDetail.tradeExtInfo.bizType &&
                tradeDetail.tradeExtInfo.bizType != 8 &&
                tradeDetail.tradeExtInfo.bizType != 9 &&
                tradeDetail.tradeExtInfo.bizType != 20 &&
                tradeDetail.tradeExtInfo.bizType != 23 &&
                tradeDetail.tradeExtInfo.bizType != 10 &&
                tradeDetail.tradeExtInfo.bizType != 30);
            if (
              tradeDetail.orderType == 20 &&
              tradeDetail.tradeExtInfo.bizType == 19
            ) {
              if (tradeDetail.ownerType != "3") {
                vm.red_envelope = true;
              } else {
                vm.red_envelope = false;
              }
            }

            vm.loading = 0;
            vm.userId = userId;
            vm.ddtoken = ddtoken;
            vm.skinModel = skinModel;
            vm.initBridge();
          });
        });
    }
  },
  methods: {
    initBridge() {
      var vm = this;
      var baseInfo = {
        tradeDetail: this.tradeDetail
      };
      setupWebViewJavascriptBridge(function (bridge) {
        vm.bridge = bridge;
        if (!window.isIOS) {
          bridge.init(function (message, responseCallback) { });
        }
        bridge.callHandler("baseInfo", baseInfo, function () { });
      });
    },

    redEnvelope() {
      if (!this.bridge) return;
      if (this.red_envelope) {
        this.bridge.callHandler("redEnvelope");
      }
    },

    goShop() {
      const { shopId, circleId } = this.tradeDetail.tradeExtInfo;
      this.bridge && this.bridge.callHandler("goShop", { shopId, circleId });
    },
    settleRatio() {
      this.bridge &&
        this.bridge.callHandler("appHint", {
          doneText: "我知道了",
          content:
            "按照开播时刻分成比结算直播场次收入，即本场获得铛铛币/10*分成比"
        });
    },
    currTaxAmount() {
      this.bridge &&
        this.bridge.callHandler("appHint", {
          doneText: "我知道了",
          content: "按照劳务报酬所得预扣税款计算直播场次收入"
        });
    }
  }
};
</script>

<style scoped lang="less">
@import "~assets/lib/mixin";

.trade-base-info {
  padding: 42px 0 40px;
  margin: 0 30px;
  // .setLine("bottom", #E5E5E5);
  border-bottom: 0.5px solid #e5e5e5;

  p {
    text-align: center;
  }

  .trade-money {
    line-height: 30px;
    font-weight: 600;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    color: #000000;

    span {
      font-family: PingFangSC-Regular;
      font-size: 17px;
      color: #1a1a1a;
      margin-left: 4px;
      font-weight: normal;
    }
  }

  .trade-ways {
    margin-top: 8px;
    line-height: 16px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #000000;
  }
}

.trade-base-info-tixian {
  padding: 30px 0 48px;
  margin: 0 30px;
  border-bottom: 0.5px solid #E5E5E5;

  .trade-object-image {
    width: 54px;
    height: 54px;
    object-fit: contain;
    border-radius: 50%;
    margin: 0 auto;
    display: block;
  }

  p {
    text-align: center;
  }

  .trade-ways {
    margin-top: 20px;
    line-height: 17px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #1A1A1A;
  }

  .trade-money {
    margin-top: 18px;
    line-height: 30px;
    font-weight: 600;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    color: #000000;
  }

}

.trade-detail-info {
  padding: 23px 30px 20px;

  .detail-item {
    .flex();
    .justify-content(space-between);
    line-height: 30px;

    span {
      font-family: PingFangSC-Regular;
      font-size: 15px;
    }

    .detail-sub-title {
      color: #888888;
      min-width: 60px;
      margin-right: 15px;
      display: flex;
      align-items: center;

      &.detail-sub-failreason {}

      .settleRatio,
      .currTaxAmount {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url("~assets/settleRatio.png") center no-repeat;
        background-size: contain;
        margin-left: 5px;
      }
    }

    .detail-sub-content {
      color: #000;

      &.red-envelope {
        color: #007aff;

        &:active {
          color: #005abc;
        }
      }

      .goods-name {
        max-width: 200px;
        .one-line;
      }
    }
  }
}

.no-pocket-wrap {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 17px;
  color: #888888;
  line-height: 17px;
  margin-top: 34vh;
  text-align: center;
}

.pocket-wrap-dark {
  .trade-base-info {
    border-bottom: 0.5px solid #242424;

    .trade-money {
      color: #d1d1d1;

      span {
        color: #d1d1d1;
      }
    }

    .trade-ways {
      color: #d1d1d1;
    }
  }

  .trade-base-info-tixian {
    border-bottom: 0.5px solid #242424;

    .trade-ways {
      color: #d1d1d1;
    }

    .trade-money {
      color: #d1d1d1;
    }
  }

  .trade-detail-info {
    .detail-item {
      .detail-sub-title {
        color: #8b8b8b;
      }

      .detail-sub-content {
        color: #d1d1d1;

        &.red-envelope {
          color: #007aff;

          &:active {
            color: #005abc;
          }
        }
      }
    }
  }
}

.spinner-wrap {
  .snake-wrap {
    width: 28px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/trade/detail.vue